import { useEffect, useRef, useState } from 'react';
import { onAuthChange, logout } from '../firebase/auth';

const INACTIVITY_LIMIT = 8 * 60 * 60 * 1000; // 8 hours

export default function useAdminAuth() {
  const [user, setUser]       = useState(undefined); // undefined = loading
  const timerRef              = useRef(null);

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => logout(), INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const unsub = onAuthChange(u => setUser(u ?? null));
    return unsub;
  }, []);

  useEffect(() => {
    if (!user) return;
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();
    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      clearTimeout(timerRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {
    user,
    loading: user === undefined,
    isAuthed: !!user,
    logout,
  };
}
